
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowDown } from "lucide-react";
import ClustrLogo from "@/components/icons/ClustrLogo";

const HeroSection = () => {
  const handleSignUpClick = () => {
    // Analytics tracking removed
  };

  const handleSignInClick = () => {
    // Analytics tracking removed
  };

  return (
    <header className="relative flex flex-col items-center justify-center px-6 py-8 md:min-h-screen">
      <nav className="absolute top-0 left-0 right-0 flex items-center justify-between p-6 md:p-8">
        <div>
          <ClustrLogo width={180} height={54} />
        </div>
        <div className="flex items-center space-x-4">
          <Button asChild variant="ghost" className="font-medium" onClick={handleSignInClick}>
            <Link to="/auth">Sign in</Link>
          </Button>
          <Button asChild className="bg-clustr-blue hover:bg-blue-600 transition-colors" onClick={handleSignUpClick}>
            <Link to="/auth">Get started</Link>
          </Button>
        </div>
      </nav>

      <div className="max-w-3xl text-center space-y-6 animate-fade-up mt-48 md:mt-0">
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight">
          Your personal library for <span className="bg-gradient-to-r from-clustr-blue to-clustr-magenta bg-clip-text text-transparent">digital inspiration</span>
        </h1>
        <p className="text-lg md:text-xl text-clustr-darkGray max-w-2xl mx-auto">
          Save, organize, and rediscover content from across the internet. The perfect tool for creative professionals to build their own knowledge base of inspiration and reference materials.
        </p>
        <div className="pt-6">
          <Button 
            asChild 
            size="lg" 
            className="px-6 py-6 text-lg bg-clustr-blue hover:bg-blue-600 transition-colors animate-float"
            onClick={handleSignUpClick}
          >
            <Link to="/auth">
              Start building your library <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>
        </div>
      </div>

      <div className="absolute bottom-5 hidden md:block w-full">
        <div className="flex justify-center">
          <ArrowDown className="h-6 w-6 text-clustr-mediumGray animate-bounce" />
        </div>
      </div>
    </header>
  );
};

export default HeroSection;
